import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/dissertation/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + '/dissertation/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/dissertation', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/dissertation', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/dissertation/' + id)
  },

  async findAllAcceptedByFilters(page, dissertationDegreeId, specialityId) {
    const { data } = await repository.get(
      baseURL +
        `/dissertation/findAllAcceptedByFilters/${page}?dissertationDegreeId=${
          dissertationDegreeId || ''
        }&specialityId=${specialityId || ''}`
    )
    return data
  }
}
